<template>
  <div id="printableArea">
    <div v-if="TempFactor.tempFactor.isRasmi == true" class="container-fluid pt-4" dir="rtl">
      <div class="row p-3 mx-1">
        <div class="col-2 p-0">
          <img :src="$cookies.get('URL') + $session.get('CompanyLogo')" alt="Logo" style="max-width: 40%" />
        </div>
        <div class="col-md-8 col-12 text-center">
          <span class="mb-2 font-weight-bold mr-5 d-block" style="font-size: 20px">پیش فاکتور فروش کالا و خدمات </span>
          <span class="font-weight-bold text-danger d-block mr-5" style="font-size: 12px"> این پیش فاکتور فاقد ارزش و اعتبار حقوقی و درج در سایت های امور مالیاتی ، دارایی ، بیمه و ... می باشد. </span>
        </div>
        <div class="col-2"></div>
        <div class="col-md-12 col-12 text-center">
          <span class="float-right">
            <small> تاریخ چاپ : </small><span>{{ $GetJalaliDateTime() }}</span>
          </span>
          <span class="float-left">
            <small> شماره سریال : </small>{{ TempFactor.tempFactor.serial }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <small> تاریخ صدور : </small><span>{{ TempFactor.tempFactor.tempFactorDate }}</span>
          </span>
        </div>
      </div>
      <!-- فروشنده -->
      <div class="row mt-2 pt-1 mx-1 D_Products Font-Size">
        <div class="col-12 text-center border-bottom bg_RowSum mb-3 font-weight-bold">مشخصات فروشنده</div>
        <div class="col-12">
          <div class="">
            نام شخص حقیقی | حقوقی : <b>{{ TempFactor.shobe.nameShobe }}</b>
          </div>
        </div>

        <div class="col-12">
          <div class="">
            نشانی کامل : <b>{{ TempFactor.shobe.adres }} </b>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <!-- {{Shobe.ShenaseMeli}} -->
            <div class="col-md-3 col-12" v-if="TempFactor.shobe.shenaseMeli != null">
              شماره ثبت : <b> {{ TempFactor.shobe.shenaseMeli }} </b>
            </div>
            <div class="col-md-3 col-12" v-else>شماره ملی: {{ TempFactor.shobe.sabtNo }}</div>
            <div class="col-md-3 col-12">
              شماره اقتصادی : <b> {{ TempFactor.shobe.shenaseEghtesadi }} </b>
            </div>
            <div class="col-md-3 col-12">
              کد پستی : <b>{{ TempFactor.shobe.codePosti }}</b>
            </div>
            <div class="col-md-3 col-12">
              شماره تلفن : <b>{{ TempFactor.shobe.tel }}</b>
            </div>
          </div>
        </div>
      </div>

      <!-- خریدار -->
      <div class="row mt-1 mx-1 D_Products Font-Size">
        <div class="col-12 text-center border-bottom bg_RowSum mb-3 font-weight-bold">مشخصات خریدار</div>
        <div class="col-12">
          <div class="">
            نام شخص حقیقی | حقوقی : <b>{{ TempFactor.tempFactor.name }}</b>
          </div>
        </div>

        <div class="col-12">
          <div class="">
            نشانی کامل :
            <b v-if="TempFactor.address"> {{ TempFactor.address.state }} - {{ TempFactor.address.city }} - {{ TempFactor.address.adress }} </b>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 col-12">
              شماره ثبت | شماره ملی :<b v-if="TempFactor.address">{{ TempFactor.tempFactor.shomareMeli }}</b>
            </div>
            <div class="col-md-3 col-12">
              شماره اقتصادی : <b v-if="TempFactor.address">{{ TempFactor.tempFactor.codeEghtesadi }}</b>
            </div>
            <div class="col-md-3 col-12">
              کد پستی : <b v-if="TempFactor.address">{{ TempFactor.address.codePosti }}</b>
            </div>
            <div class="col-md-3 col-12">
              شماره تلفن : <b v-if="TempFactor.address">{{ TempFactor.address.tel }}</b>
            </div>
          </div>
        </div>
      </div>

      <!--Header Serial And Date -->
      <div class="row mt-2 mx-1 D_Products">
        <div class="col-12 text-center Font-Size bg_RowSum font-weight-bold">اطلاعات کالا و یا خدمات مورد معامله</div>
      </div>

      <!-- Serial And Date -->
      <div class="table-responsive">
        <table class="table table-bordered table-striped mt-2">
          <thead class="">
            <tr style="text-align: center; background: #c6c7c7 !important">
              <th style="width: 1% !important; background: #c6c7c7 !important">ردیف</th>
              <th style="width: 5% !important; background: #c6c7c7 !important">کد کالا</th>
              <th style="width: 30% !important; background: #c6c7c7 !important">شرح کالا | خدمات</th>
              <th style="width: 5% !important; background: #c6c7c7 !important">تعداد</th>
              <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ واحد <small>( ریال )</small></th>
              <!-- <th style="background: #c6c7c7 !important">مبلغ کل <small class="d-block">( ریال )</small></th> -->
              <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ تخفیف</th>
              <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ پس از تخفیف <small class="d-block">( ریال )</small></th>
              <th v-if="TempFactor.tempFactor.isRasmi" style="width: 10% !important; background: #c6c7c7 !important">جمع مالیات و عوارض <small>( ریال )</small></th>
              <th v-if="TempFactor.tempFactor.isRasmi" style="background: #c6c7c7 !important">جمع مبلغ با احتساب مالیات و عوارض <small>( ریال )</small></th>
            </tr>
          </thead>
          <tbody class="" id="GFactor">
            <tr v-for="(item, index) in TempFactor.TempFactorDetail" :key="index">
              <td style="width: 1% !important">
                <span>{{ index + 1 }}</span>
              </td>
              <td style="width: 5% !important">
                <span>{{ item.tblProductsId }}</span>
              </td>
              <td style="width: 30% !important; text-align: center">{{ item.nameProduct }}</td>
              <td style="width: 5% !important; text-align: center">{{ item.count }}</td>
              <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(item.amount) }}</td>
              <!-- <td style="text-align: center">{{ $Comma3ragham(item.amount * item.count) }}</td> -->
              <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(item.discount) }}</td>
              <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor(item.amount * item.count - item.discount)) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor((item.amount * item.count - item.discount) *(TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? ArzeshAfzode1402 : ArzeshAfzode1403))) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center">
                <span>{{ $Comma3ragham(Math.floor((item.amount * item.count - item.discount) * (TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? 1.09 : 1.1))) }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left">جمع کـــل :</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumAmount) }}</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumDiscount) }}</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumAmountDiscount) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumTollTax) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(SumTotallAmount)) }}</td>
            </tr>
            <tr class="mt-3">
              <td v-if="TempFactor.tempFactor.isRasmi" colspan="5" style="text-align: right" ><span dir="rtl">{{ TempFactor.tempFactor.tempDesc }}</span></td>
              <td v-else colspan="5" style="text-align: right"></td>
              <td colspan="5" style="text-align: right">
                <span class="mt-2">
                  جمع کل مبلغ به حروف : <b class="font-weight-bold"> {{ Mab2persian(Math.floor(SumTotallAmount)) }}</b></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="px-3">
        <span class="float-right">مهر و امضا فروشنده</span>
        <span class="float-left">مهر و امضای خریدار</span>
      </div>
    </div>

    <div v-else class="container-fluid pt-4" dir="rtl">
      <div class="row mt-2 mx-1 border border-dark p-4">
        <div class="col-12 text-center">
          <h3>پیش فاکتور فروش</h3>
        </div>
        <div class="row mt-1 mx-1 D_Products Font-Size">
          <div class="col-12 text-center border-bottom bg_RowSum mb-3 font-weight-bold">مشخصات خریدار</div>
          <div class="col-12">
            <div class="">
              نام شخص حقیقی | حقوقی : <b>{{ TempFactor.tempFactor.name }}</b>
            </div>
          </div>

          <div class="col-12">
            <div class="">
              نشانی کامل :
              <b v-if="TempFactor.address"> {{ TempFactor.address.state }} - {{ TempFactor.address.city }} - {{ TempFactor.address.adress }} </b>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-md-3 col-12">
                شماره ثبت | شماره ملی :<b v-if="TempFactor.address">{{ TempFactor.tempFactor.shomareMeli }}</b>
              </div>
              <div class="col-md-3 col-12">
                شماره اقتصادی : <b v-if="TempFactor.address">{{ TempFactor.tempFactor.codeEghtesadi }}</b>
              </div>
              <div class="col-md-3 col-12">
                کد پستی : <b v-if="TempFactor.address">{{ TempFactor.address.codePosti }}</b>
              </div>
              <div class="col-md-3 col-12">
                شماره تلفن : <b v-if="TempFactor.address">{{ TempFactor.address.tel }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mx-1 border border-dark">
        <div class="col-12 text-center p-2 font-weight-bold">لیست محصولات</div>
      </div>

      <!-- Serial And Date -->
      <div class="table-responsive p-1">
        <table class="table table-bordered mt-2">
          <thead class="">
            <tr style="text-align: center; background: #c6c7c7 !important">
              <th style="width: 1% !important; background: #c6c7c7 !important">ردیف</th>
              <th style="width: 5% !important; background: #c6c7c7 !important">کد کالا</th>
              <th style="width: 30% !important; background: #c6c7c7 !important">شرح کالا | خدمات</th>
              <th style="width: 5% !important; background: #c6c7c7 !important">تعداد</th>
              <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ واحد <small>( ریال )</small></th>
              <!-- <th style="background: #c6c7c7 !important">مبلغ کل <small class="d-block">( ریال )</small></th> -->
              <th style="width: 10% !important; background: #c6c7c7 !important">مبلغ تخفیف</th>
              <th style="width: 20% !important; background: #c6c7c7 !important">مبلغ پس از تخفیف <small class="d-block">( ریال )</small></th>
              <th v-if="TempFactor.tempFactor.isRasmi" style="width: 10% !important; background: #c6c7c7 !important">جمع مالیات و عوارض <small>( ریال )</small></th>
              <th v-if="TempFactor.tempFactor.isRasmi" style="background: #c6c7c7 !important">جمع مبلغ با احتساب مالیات و عوارض <small>( ریال )</small></th>
            </tr>
          </thead>
          <tbody class="" id="GFactor">
            <tr v-for="(item, index) in TempFactor.TempFactorDetail" :key="index">
              <td style="width: 1% !important">
                <span>{{ index + 1 }}</span>
              </td>
              <td style="width: 5% !important">
                <span>{{ item.tblProductsId }}</span>
              </td>
              <td style="width: 30% !important; text-align: center">{{ item.nameProduct }}</td>
              <td style="width: 5% !important; text-align: center">{{ item.count }}</td>
              <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(item.amount) }}</td>
              <!-- <td style="text-align: center">{{ $Comma3ragham(item.amount * item.count) }}</td> -->
              <td style="width: 10% !important; text-align: center">{{ $Comma3ragham(item.discount) }}</td>
              <td style="width: 20% !important; text-align: center">{{ $Comma3ragham(item.amount * item.count - item.discount) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="width: 10% !important; text-align: center">{{ $Comma3ragham(Math.floor((item.amount * item.count - item.discount) *(TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? ArzeshAfzode1402 : ArzeshAfzode1403))) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center">
                <span>{{ $Comma3ragham(Math.floor((item.amount * item.count - item.discount) * (TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? 1.09 : 1.1))) }}-*-- </span>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: left">جمع کـــل :</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumAmount) }}</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumDiscount) }}</td>
              <td style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(SumAmountDiscount) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(SumTollTax)) }}</td>
              <td v-if="TempFactor.tempFactor.isRasmi" style="text-align: center; background: #c6c7c7 !important" class="bg_RowSum">{{ $Comma3ragham(Math.floor(SumTotallAmount)) }}</td>
            </tr>
            <tr class="mt-3">
              <td v-if="TempFactor.tempFactor.isRasmi" colspan="5" style="text-align: right">{{ TempFactor.tempFactor.tempDesc }} </td>
              <td v-else colspan="5" style="text-align: right"></td>
              <td colspan="5" style="text-align: right">
                <span class="mt-2">
                  جمع کل مبلغ به حروف : <b class="font-weight-bold"> {{ Mab2persian(Math.floor(SumTotallAmount)) }}</b></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="px-3">
        <span class="float-right">مهر و امضا فروشنده</span>
        <img style="margin-top: -130px; margin-right: -30px" src="/assets/pics/Emza.png" alt="Emza" width="400" />

        <span class="float-left">مهر و امضای خریدار</span>
      </div>
    </div>

    <div class="d-block mt-5">
      <button class="bg-success btn no-print mt-5 px-3 text-light Pointer" @click="print">چاپ سند</button>
      <!-- <button class="bg-success btn no-print mt-5 px-3 text-light Pointer" @click="printPageArea">2چاپ سند</button> -->
    </div>
    <button v-if="$session.has('CustomerInfo')" class="btn bg-warning no-print float-left" @click="$router.go(-1)">بازگشت</button>
    <button v-else class="btn bg-warning no-print float-left" @click="returnToCustomer">بازگشت به مشتری</button>
  </div>
</template>
<script>
import Num2persian from 'num2persian'

export default {
  props: ['propsTempFactor'],
  data() {
    return {
      ArzeshAfzode1402:0.09,
      ArzeshAfzode1403 :0.1,
      TempFactor: {},
    }
  },
  computed: {
    SumAmount() {
      var result = 0
      this.TempFactor.TempFactorDetail.forEach((element) => {
        result += element.amount * element.count
      })
      return result
    },
    SumDiscount() {
      var result = 0
      this.TempFactor.TempFactorDetail.forEach((element) => {
        result += element.discount
      })
      console.warn(result)
      return result
    },
    SumAmountDiscount() {
      var result = 0
      this.TempFactor.TempFactorDetail.forEach((element) => {
        result += element.amount * element.count - element.discount
      })
      return result
    },
    SumTollTax() {
      var result = 0

      result += (this.SumAmount - this.SumDiscount) *(this.TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? this.ArzeshAfzode1402 : this.ArzeshAfzode1403)

      console.log(result)

      return result
    },
    SumTotallAmount() {
      var result = 0
      this.TempFactor.TempFactorDetail.forEach((element) => {
        if (this.TempFactor.tempFactor.isRasmi) {
          result += (element.amount * element.count - element.discount) * (this.TempFactor.tempFactor.tempFactorDate.substring(0, 4)<'1403' ? 1.09 : 1.1)
          console.log(result);
        } else {
          result += element.amount * element.count - element.discount
        }
      })
      return result
    },
  },
  mounted() {
    if (this.propsTempFactor) {
      var GetTempAxios = { Method: 'POST', Action: 'TempFactor/GetById', ArryfildValue: { Id: Number(this.propsTempFactor.Id) } }
    } else {
      var data = this.$route.query
      // console.log(this.$DecryptionWithCryptoJS(data.Id))
      var Id = data.Id
      // console.warn(this.$Encryption(2007))
      var GetTempAxios = { Method: 'POST', Action: 'TempFactor/GetById', ArryfildValue: { Id: Number(Id) } }
    }
    this.$PostData(GetTempAxios).then((result) => {
      if (result.status == 'success') {
        console.warn(result)
        // console.log(result)

        this.TempFactor = { tempFactor: result.tempFactor, TempFactorDetail: result.tempFactorDetail, address: result.address, shobe: result.shobe }
        console.warn(this.TempFactor)
      } else {
      }
    })
  },
  methods: {
    print() {
      var css = '@page { size: landscape; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style')
      style.type = 'text/css'
      style.media = 'print'
      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }
      head.appendChild(style)
      document.getElementsByTagName('title')[0].innerHTML = 'پیش فاکتور -' + this.TempFactor.tempFactor.codeBazaryabi
      window.print()
    },
    returnToCustomer() {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: this.TempFactor.tempFactor.tblCustomerId, activeTab: 11 } })
      this.$FindeCustomerById('DetailCustomer', this.TempFactor.tempFactor.tblCustomerId, 11, null)
    },
    Mab2persian(mab) {
      return Num2persian(mab) + ' ریال '
    },
    // printPageArea() {
    //   var mywindow = window.open('', 'PRINT')
    //   mywindow.document.write('<html><head>')
    //   mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
    //   mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
    //   mywindow.document.write('<link rel="stylesheet" href="/assets/print/style.css">')
    //   mywindow.document.write('</head><body  dir="rtl">')
    //   mywindow.document.write(document.getElementById('printableArea').innerHTML)
    //   mywindow.document.write('</body></html>')
    //   mywindow.document.close()
    //   mywindow.focus()
    //   return true
    // },
  },
}
</script>
<style scoped>
.D_Products {
  border: 1px solid #dbdddc;
  border-radius: 5px;
}
.bg_RowSum {
  background: #c6c7c7 !important;
}
@media print {
  .no-print {
    display: none;
  }
}
table td {
  font-size: 10px !important;
}
table th {
  font-weight: bold !important;
  font-size: 11px !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #e5eaea !important;
}
b {
  font-weight: bold !important;
}
.Font-Size {
  font-size: 11px !important;
}

td {
  border-color: rgb(137, 137, 137) !important;
}
th {
  border-color: rgb(137, 137, 137) !important;
}
thead {
  border-color: rgb(137, 137, 137) !important;
}
</style>
